import './dsgvo-api-maps.scss';
import mapStylesJsonBright from './map-styles.json';
import mapStylesJsonDark from './map-styles-dark.json'


import { Loader } from '@googlemaps/js-api-loader';




const apiKey = 'AIzaSyDWJUXSzWVG8iAqFwBX3UhkHL0GwPC4QdA';



let mapStatus = {
    googleMapLoaded: false,
    darkMode: false,
    iconFolder: undefined
}

const loader = new Loader({
    apiKey,
    version: "weekly",
})



const setIconFolder = () => {
    mapStatus.iconFolder = !mapStatus.darkMode ? `${window.theme_directory}/assets/mapmarker/brightMode/` : `${window.theme_directory}/assets/mapmarker/darkMode/`;
}

setIconFolder();

let map;


//Elements
const loaderBTN = document.getElementById('mapLoaderBtn');
// const zoomInBtn = document.getElementById('zoomIn');
// const zoomOutBtn = document.getElementById('zoomOut');
const darkModeBtn = document.getElementById('darkMode');
const mapSection = document.getElementById('map-section');
// const modalMapLoaderBtn = document.getElementById('modalMapLoader');


const loadMyMap = () => {
    loader.load()
        .then(() => {
            initMap();
            initMarkers();
            // initCircle();
            mapStatus.googleMapLoaded = true;
        })
        .catch(e => {
            alert('connection error with google maps')
        });
}

const markers = [
    {
        title: 'Knolle Societät',
        lat: 50.10521377367852,
        lng: 8.766768840584634,
    },
    {
        title: 'S Bahn Marktplatz',
        lat: 50.105301982183896,
        lng: 8.765379223180298,
    },
    {
        title: 'Tiefgaragen Parkplatz',
        lat: 50.10490630899607,
        lng: 8.767310413473492,
    },
    {
        title: 'Wochenmarkt',
        lat: 50.103618891942936,
        lng: 8.76691415100369,
    },

]


const initMap = () => {
    map = new google.maps.Map(
        document.getElementById("map"), {
        zoom: 17,
        styles: mapStylesJsonBright,
        mapTypeControl: false,
        streetViewControl: false,
        center: {
            lat: markers[0].lat,
            lng: markers[0].lng
        },
    }
    );
    window.googleMap = map;

}

const initMarkers = () => {
    markers.forEach((marker, index) => {
        const markerConfig = {
            position: {
                lat: marker.lat,
                lng: marker.lng
            },
            icon: index === 0 ? `${mapStatus.iconFolder}map-marker.png` : `${mapStatus.iconFolder}sec-marker-pale.png`,
            optimized: index === 0 ? false : true,
            zIndex: index === 0 ? 99999 : undefined,
            title: marker.title,
            animation: google.maps.Animation.DROP
        }
        const timeOut = index * 125;
        addMarkerWithDelay(markerConfig, timeOut)
    }
    )
}

const addMarkerWithDelay = (config, timeOut) => {

    window.setTimeout(() => {
        new google.maps.Marker({
            ...config, map
        });
    }, timeOut);
}

// Events
const showDarkmodeBtn = () => {
    $(darkModeBtn).slideDown()

}

const hideDarkmodeBtn = () => {
    $(darkModeBtn).css({ display: "none", })
}
hideDarkmodeBtn()


loaderBTN.addEventListener('click', () => {
    loadMyMap();
    showDarkmodeBtn();
})






darkModeBtn.addEventListener('click', () => {
    if (mapStatus.googleMapLoaded) {
        map.setOptions({
            styles: mapStatus.darkMode === true ? mapStylesJsonBright : mapStylesJsonDark
        })

        mapSection.classList.toggle('dark-mode')
        mapStatus.darkMode = !mapStatus.darkMode;
        setIconFolder();
        initMarkers();
    }
    else {
        alert('you must load the map to use this feature')
    }

})


